import { TrustedTypePolicy } from 'trusted-types'

/**
 * This policy returns Trusted Types for just HTML Strings
 */
export const elevationsTTPolicy: TrustedTypePolicy = (window as any).trustedTypes.createPolicy('insecureElevationsPolicy', {
  createHTML: (htmlString: string) => htmlString
});
